import React, { FC, HTMLAttributes, ReactElement, ReactNode, forwardRef } from "react";

import classnames from "classnames";
import { twMerge } from "tailwind-merge";

export type JoinDirection = "horizontal" | "vertical" | "responsive";

export interface JoinProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  direction?: JoinDirection;
}

export interface JoinItemProps {
  children: ReactElement<{ className?: string }>;
  className?: string;
}

/**
 * Cobalt Join container - Based on DaisyUI join classes
 * @see https://daisyui.com/components/join/
 */
const Join = forwardRef<HTMLDivElement, JoinProps>(({ children, className, direction = "horizontal", ...rest }, ref) => {
  const classes = twMerge(
    "si-join",
    classnames({
      "si-join-horizontal": direction === "horizontal",
      "si-join-vertical": direction === "vertical",
      "si-join-vertical lg:si-join-horizontal": direction === "responsive",
    }),
    className,
  );

  return (
    <div ref={ref} className={classes} {...rest}>
      {children}
    </div>
  );
});

Join.displayName = "Join";

export const JoinItem: FC<JoinItemProps> = ({ children, className }) =>
  React.cloneElement(children, {
    className: twMerge("si-join-item", children.props.className, className),
  });

export default Join;
